// @generated by protobuf-ts 2.6.0
// @generated from protobuf file "scoreconnect.proto" (package "VpuScoreconnectGrpc", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message VpuScoreconnectGrpc.Configuration
 */
export interface Configuration {
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.ScoreLinkDeviceType scoreLinkDevice = 1;
     */
    scoreLinkDevice: ScoreLinkDeviceType;
    /**
     * @generated from protobuf field: int32 vendorId = 2;
     */
    vendorId: number;
    /**
     * @generated from protobuf field: int32 vendorSportId = 3;
     */
    vendorSportId: number;
    /**
     * @generated from protobuf field: int32 vendorConfigurationId = 4;
     */
    vendorConfigurationId: number;
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.Configuration.AddtionalVendorConfigurationFields additionalVendorConfigurationFields = 5;
     */
    additionalVendorConfigurationFields?: Configuration_AddtionalVendorConfigurationFields;
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.LanScoreLinkDevice scorelinkLanDevice = 6;
     */
    scorelinkLanDevice?: LanScoreLinkDevice;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.Configuration.AddtionalVendorConfigurationFields
 */
export interface Configuration_AddtionalVendorConfigurationFields {
    /**
     * @generated from protobuf field: int32 group = 1;
     */
    group: number;
    /**
     * @generated from protobuf field: int32 channel = 2;
     */
    channel: number;
    /**
     * @generated from protobuf field: bool externalAntenna = 3;
     */
    externalAntenna: boolean;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.VendorList
 */
export interface VendorList {
    /**
     * @generated from protobuf field: repeated VpuScoreconnectGrpc.Vendor vendorList = 1;
     */
    vendorList: Vendor[];
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.Vendor
 */
export interface Vendor {
    /**
     * @generated from protobuf field: int32 vendorId = 1;
     */
    vendorId: number;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.VendorSportsList
 */
export interface VendorSportsList {
    /**
     * @generated from protobuf field: repeated VpuScoreconnectGrpc.VendorSport vendorSportsList = 1;
     */
    vendorSportsList: VendorSport[];
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.VendorSport
 */
export interface VendorSport {
    /**
     * @generated from protobuf field: int32 vendorSportId = 1;
     */
    vendorSportId: number;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.VendorConfigurationList
 */
export interface VendorConfigurationList {
    /**
     * @generated from protobuf field: repeated VpuScoreconnectGrpc.VendorConfiguration vendorConfigurationList = 1;
     */
    vendorConfigurationList: VendorConfiguration[];
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.VendorConfiguration
 */
export interface VendorConfiguration {
    /**
     * @generated from protobuf field: int32 vendorConfigurationId = 1;
     */
    vendorConfigurationId: number;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.VendorConfiguration.AddtionalFields requiredAdditionalFields = 3;
     */
    requiredAdditionalFields?: VendorConfiguration_AddtionalFields;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.VendorConfiguration.AddtionalFields
 */
export interface VendorConfiguration_AddtionalFields {
    /**
     * @generated from protobuf field: bool group = 1;
     */
    group: boolean;
    /**
     * @generated from protobuf field: bool channel = 2;
     */
    channel: boolean;
    /**
     * @generated from protobuf field: bool externalAntenna = 3;
     */
    externalAntenna: boolean;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.StatusResponse
 */
export interface StatusResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.BotnumberMessage
 */
export interface BotnumberMessage {
    /**
     * @generated from protobuf field: int32 botNumber = 1;
     */
    botNumber: number; // return -1 if not configured
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.ScoreBoardDataMessage
 */
export interface ScoreBoardDataMessage {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
    /**
     * @generated from protobuf field: string clock = 2;
     */
    clock: string;
    /**
     * @generated from protobuf field: int32 homeScore = 3;
     */
    homeScore: number;
    /**
     * @generated from protobuf field: int32 awayScore = 4;
     */
    awayScore: number;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.LanScoreLinkDeviceList
 */
export interface LanScoreLinkDeviceList {
    /**
     * @generated from protobuf field: repeated VpuScoreconnectGrpc.LanScoreLinkDevice lanScoreLinkDeviceList = 1;
     */
    lanScoreLinkDeviceList: LanScoreLinkDevice[];
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.LanScoreLinkDevice
 */
export interface LanScoreLinkDevice {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string ip = 3;
     */
    ip: string;
    /**
     * @generated from protobuf field: string mac = 4;
     */
    mac: string;
    /**
     * @generated from protobuf field: int32 botNumber = 5;
     */
    botNumber: number;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.SwapTeamDataResponse
 */
export interface SwapTeamDataResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * @generated from protobuf message VpuScoreconnectGrpc.Empty
 */
export interface Empty {
}
/**
 * @generated from protobuf enum VpuScoreconnectGrpc.ScoreLinkDeviceType
 */
export enum ScoreLinkDeviceType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: ScoreLink1USB = 1;
     */
    ScoreLink1USB = 1,
    /**
     * @generated from protobuf enum value: ScoreLink2USB = 2;
     */
    ScoreLink2USB = 2,
    /**
     * @generated from protobuf enum value: ScoreLinkLAN = 3;
     */
    ScoreLinkLAN = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Configuration$Type extends MessageType<Configuration> {
    constructor() {
        super("VpuScoreconnectGrpc.Configuration", [
            { no: 1, name: "scoreLinkDevice", kind: "enum", T: () => ["VpuScoreconnectGrpc.ScoreLinkDeviceType", ScoreLinkDeviceType] },
            { no: 2, name: "vendorId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "vendorSportId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "vendorConfigurationId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "additionalVendorConfigurationFields", kind: "message", T: () => Configuration_AddtionalVendorConfigurationFields },
            { no: 6, name: "scorelinkLanDevice", kind: "message", T: () => LanScoreLinkDevice }
        ]);
    }
    create(value?: PartialMessage<Configuration>): Configuration {
        const message = { scoreLinkDevice: 0, vendorId: 0, vendorSportId: 0, vendorConfigurationId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Configuration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Configuration): Configuration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuScoreconnectGrpc.ScoreLinkDeviceType scoreLinkDevice */ 1:
                    message.scoreLinkDevice = reader.int32();
                    break;
                case /* int32 vendorId */ 2:
                    message.vendorId = reader.int32();
                    break;
                case /* int32 vendorSportId */ 3:
                    message.vendorSportId = reader.int32();
                    break;
                case /* int32 vendorConfigurationId */ 4:
                    message.vendorConfigurationId = reader.int32();
                    break;
                case /* VpuScoreconnectGrpc.Configuration.AddtionalVendorConfigurationFields additionalVendorConfigurationFields */ 5:
                    message.additionalVendorConfigurationFields = Configuration_AddtionalVendorConfigurationFields.internalBinaryRead(reader, reader.uint32(), options, message.additionalVendorConfigurationFields);
                    break;
                case /* VpuScoreconnectGrpc.LanScoreLinkDevice scorelinkLanDevice */ 6:
                    message.scorelinkLanDevice = LanScoreLinkDevice.internalBinaryRead(reader, reader.uint32(), options, message.scorelinkLanDevice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Configuration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuScoreconnectGrpc.ScoreLinkDeviceType scoreLinkDevice = 1; */
        if (message.scoreLinkDevice !== 0)
            writer.tag(1, WireType.Varint).int32(message.scoreLinkDevice);
        /* int32 vendorId = 2; */
        if (message.vendorId !== 0)
            writer.tag(2, WireType.Varint).int32(message.vendorId);
        /* int32 vendorSportId = 3; */
        if (message.vendorSportId !== 0)
            writer.tag(3, WireType.Varint).int32(message.vendorSportId);
        /* int32 vendorConfigurationId = 4; */
        if (message.vendorConfigurationId !== 0)
            writer.tag(4, WireType.Varint).int32(message.vendorConfigurationId);
        /* VpuScoreconnectGrpc.Configuration.AddtionalVendorConfigurationFields additionalVendorConfigurationFields = 5; */
        if (message.additionalVendorConfigurationFields)
            Configuration_AddtionalVendorConfigurationFields.internalBinaryWrite(message.additionalVendorConfigurationFields, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* VpuScoreconnectGrpc.LanScoreLinkDevice scorelinkLanDevice = 6; */
        if (message.scorelinkLanDevice)
            LanScoreLinkDevice.internalBinaryWrite(message.scorelinkLanDevice, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.Configuration
 */
export const Configuration = new Configuration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Configuration_AddtionalVendorConfigurationFields$Type extends MessageType<Configuration_AddtionalVendorConfigurationFields> {
    constructor() {
        super("VpuScoreconnectGrpc.Configuration.AddtionalVendorConfigurationFields", [
            { no: 1, name: "group", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "channel", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "externalAntenna", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Configuration_AddtionalVendorConfigurationFields>): Configuration_AddtionalVendorConfigurationFields {
        const message = { group: 0, channel: 0, externalAntenna: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Configuration_AddtionalVendorConfigurationFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Configuration_AddtionalVendorConfigurationFields): Configuration_AddtionalVendorConfigurationFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 group */ 1:
                    message.group = reader.int32();
                    break;
                case /* int32 channel */ 2:
                    message.channel = reader.int32();
                    break;
                case /* bool externalAntenna */ 3:
                    message.externalAntenna = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Configuration_AddtionalVendorConfigurationFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 group = 1; */
        if (message.group !== 0)
            writer.tag(1, WireType.Varint).int32(message.group);
        /* int32 channel = 2; */
        if (message.channel !== 0)
            writer.tag(2, WireType.Varint).int32(message.channel);
        /* bool externalAntenna = 3; */
        if (message.externalAntenna !== false)
            writer.tag(3, WireType.Varint).bool(message.externalAntenna);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.Configuration.AddtionalVendorConfigurationFields
 */
export const Configuration_AddtionalVendorConfigurationFields = new Configuration_AddtionalVendorConfigurationFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorList$Type extends MessageType<VendorList> {
    constructor() {
        super("VpuScoreconnectGrpc.VendorList", [
            { no: 1, name: "vendorList", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Vendor }
        ]);
    }
    create(value?: PartialMessage<VendorList>): VendorList {
        const message = { vendorList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VendorList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorList): VendorList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VpuScoreconnectGrpc.Vendor vendorList */ 1:
                    message.vendorList.push(Vendor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated VpuScoreconnectGrpc.Vendor vendorList = 1; */
        for (let i = 0; i < message.vendorList.length; i++)
            Vendor.internalBinaryWrite(message.vendorList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.VendorList
 */
export const VendorList = new VendorList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vendor$Type extends MessageType<Vendor> {
    constructor() {
        super("VpuScoreconnectGrpc.Vendor", [
            { no: 1, name: "vendorId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Vendor>): Vendor {
        const message = { vendorId: 0, description: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Vendor>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Vendor): Vendor {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 vendorId */ 1:
                    message.vendorId = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Vendor, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 vendorId = 1; */
        if (message.vendorId !== 0)
            writer.tag(1, WireType.Varint).int32(message.vendorId);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.Vendor
 */
export const Vendor = new Vendor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorSportsList$Type extends MessageType<VendorSportsList> {
    constructor() {
        super("VpuScoreconnectGrpc.VendorSportsList", [
            { no: 1, name: "vendorSportsList", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VendorSport }
        ]);
    }
    create(value?: PartialMessage<VendorSportsList>): VendorSportsList {
        const message = { vendorSportsList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VendorSportsList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorSportsList): VendorSportsList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VpuScoreconnectGrpc.VendorSport vendorSportsList */ 1:
                    message.vendorSportsList.push(VendorSport.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorSportsList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated VpuScoreconnectGrpc.VendorSport vendorSportsList = 1; */
        for (let i = 0; i < message.vendorSportsList.length; i++)
            VendorSport.internalBinaryWrite(message.vendorSportsList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.VendorSportsList
 */
export const VendorSportsList = new VendorSportsList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorSport$Type extends MessageType<VendorSport> {
    constructor() {
        super("VpuScoreconnectGrpc.VendorSport", [
            { no: 1, name: "vendorSportId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VendorSport>): VendorSport {
        const message = { vendorSportId: 0, description: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VendorSport>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorSport): VendorSport {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 vendorSportId */ 1:
                    message.vendorSportId = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorSport, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 vendorSportId = 1; */
        if (message.vendorSportId !== 0)
            writer.tag(1, WireType.Varint).int32(message.vendorSportId);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.VendorSport
 */
export const VendorSport = new VendorSport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorConfigurationList$Type extends MessageType<VendorConfigurationList> {
    constructor() {
        super("VpuScoreconnectGrpc.VendorConfigurationList", [
            { no: 1, name: "vendorConfigurationList", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VendorConfiguration }
        ]);
    }
    create(value?: PartialMessage<VendorConfigurationList>): VendorConfigurationList {
        const message = { vendorConfigurationList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VendorConfigurationList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorConfigurationList): VendorConfigurationList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VpuScoreconnectGrpc.VendorConfiguration vendorConfigurationList */ 1:
                    message.vendorConfigurationList.push(VendorConfiguration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorConfigurationList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated VpuScoreconnectGrpc.VendorConfiguration vendorConfigurationList = 1; */
        for (let i = 0; i < message.vendorConfigurationList.length; i++)
            VendorConfiguration.internalBinaryWrite(message.vendorConfigurationList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.VendorConfigurationList
 */
export const VendorConfigurationList = new VendorConfigurationList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorConfiguration$Type extends MessageType<VendorConfiguration> {
    constructor() {
        super("VpuScoreconnectGrpc.VendorConfiguration", [
            { no: 1, name: "vendorConfigurationId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "requiredAdditionalFields", kind: "message", T: () => VendorConfiguration_AddtionalFields }
        ]);
    }
    create(value?: PartialMessage<VendorConfiguration>): VendorConfiguration {
        const message = { vendorConfigurationId: 0, description: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VendorConfiguration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorConfiguration): VendorConfiguration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 vendorConfigurationId */ 1:
                    message.vendorConfigurationId = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* VpuScoreconnectGrpc.VendorConfiguration.AddtionalFields requiredAdditionalFields */ 3:
                    message.requiredAdditionalFields = VendorConfiguration_AddtionalFields.internalBinaryRead(reader, reader.uint32(), options, message.requiredAdditionalFields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorConfiguration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 vendorConfigurationId = 1; */
        if (message.vendorConfigurationId !== 0)
            writer.tag(1, WireType.Varint).int32(message.vendorConfigurationId);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* VpuScoreconnectGrpc.VendorConfiguration.AddtionalFields requiredAdditionalFields = 3; */
        if (message.requiredAdditionalFields)
            VendorConfiguration_AddtionalFields.internalBinaryWrite(message.requiredAdditionalFields, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.VendorConfiguration
 */
export const VendorConfiguration = new VendorConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorConfiguration_AddtionalFields$Type extends MessageType<VendorConfiguration_AddtionalFields> {
    constructor() {
        super("VpuScoreconnectGrpc.VendorConfiguration.AddtionalFields", [
            { no: 1, name: "group", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "channel", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "externalAntenna", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<VendorConfiguration_AddtionalFields>): VendorConfiguration_AddtionalFields {
        const message = { group: false, channel: false, externalAntenna: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VendorConfiguration_AddtionalFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorConfiguration_AddtionalFields): VendorConfiguration_AddtionalFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool group */ 1:
                    message.group = reader.bool();
                    break;
                case /* bool channel */ 2:
                    message.channel = reader.bool();
                    break;
                case /* bool externalAntenna */ 3:
                    message.externalAntenna = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorConfiguration_AddtionalFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool group = 1; */
        if (message.group !== false)
            writer.tag(1, WireType.Varint).bool(message.group);
        /* bool channel = 2; */
        if (message.channel !== false)
            writer.tag(2, WireType.Varint).bool(message.channel);
        /* bool externalAntenna = 3; */
        if (message.externalAntenna !== false)
            writer.tag(3, WireType.Varint).bool(message.externalAntenna);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.VendorConfiguration.AddtionalFields
 */
export const VendorConfiguration_AddtionalFields = new VendorConfiguration_AddtionalFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatusResponse$Type extends MessageType<StatusResponse> {
    constructor() {
        super("VpuScoreconnectGrpc.StatusResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StatusResponse>): StatusResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatusResponse): StatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.StatusResponse
 */
export const StatusResponse = new StatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotnumberMessage$Type extends MessageType<BotnumberMessage> {
    constructor() {
        super("VpuScoreconnectGrpc.BotnumberMessage", [
            { no: 1, name: "botNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BotnumberMessage>): BotnumberMessage {
        const message = { botNumber: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BotnumberMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BotnumberMessage): BotnumberMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 botNumber */ 1:
                    message.botNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BotnumberMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 botNumber = 1; */
        if (message.botNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.botNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.BotnumberMessage
 */
export const BotnumberMessage = new BotnumberMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScoreBoardDataMessage$Type extends MessageType<ScoreBoardDataMessage> {
    constructor() {
        super("VpuScoreconnectGrpc.ScoreBoardDataMessage", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "clock", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "homeScore", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "awayScore", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ScoreBoardDataMessage>): ScoreBoardDataMessage {
        const message = { sportType: "", clock: "", homeScore: 0, awayScore: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ScoreBoardDataMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScoreBoardDataMessage): ScoreBoardDataMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                case /* string clock */ 2:
                    message.clock = reader.string();
                    break;
                case /* int32 homeScore */ 3:
                    message.homeScore = reader.int32();
                    break;
                case /* int32 awayScore */ 4:
                    message.awayScore = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScoreBoardDataMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        /* string clock = 2; */
        if (message.clock !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clock);
        /* int32 homeScore = 3; */
        if (message.homeScore !== 0)
            writer.tag(3, WireType.Varint).int32(message.homeScore);
        /* int32 awayScore = 4; */
        if (message.awayScore !== 0)
            writer.tag(4, WireType.Varint).int32(message.awayScore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.ScoreBoardDataMessage
 */
export const ScoreBoardDataMessage = new ScoreBoardDataMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LanScoreLinkDeviceList$Type extends MessageType<LanScoreLinkDeviceList> {
    constructor() {
        super("VpuScoreconnectGrpc.LanScoreLinkDeviceList", [
            { no: 1, name: "lanScoreLinkDeviceList", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => LanScoreLinkDevice }
        ]);
    }
    create(value?: PartialMessage<LanScoreLinkDeviceList>): LanScoreLinkDeviceList {
        const message = { lanScoreLinkDeviceList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LanScoreLinkDeviceList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LanScoreLinkDeviceList): LanScoreLinkDeviceList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VpuScoreconnectGrpc.LanScoreLinkDevice lanScoreLinkDeviceList */ 1:
                    message.lanScoreLinkDeviceList.push(LanScoreLinkDevice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LanScoreLinkDeviceList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated VpuScoreconnectGrpc.LanScoreLinkDevice lanScoreLinkDeviceList = 1; */
        for (let i = 0; i < message.lanScoreLinkDeviceList.length; i++)
            LanScoreLinkDevice.internalBinaryWrite(message.lanScoreLinkDeviceList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.LanScoreLinkDeviceList
 */
export const LanScoreLinkDeviceList = new LanScoreLinkDeviceList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LanScoreLinkDevice$Type extends MessageType<LanScoreLinkDevice> {
    constructor() {
        super("VpuScoreconnectGrpc.LanScoreLinkDevice", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mac", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "botNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<LanScoreLinkDevice>): LanScoreLinkDevice {
        const message = { id: 0, type: "", ip: "", mac: "", botNumber: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LanScoreLinkDevice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LanScoreLinkDevice): LanScoreLinkDevice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string ip */ 3:
                    message.ip = reader.string();
                    break;
                case /* string mac */ 4:
                    message.mac = reader.string();
                    break;
                case /* int32 botNumber */ 5:
                    message.botNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LanScoreLinkDevice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string ip = 3; */
        if (message.ip !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ip);
        /* string mac = 4; */
        if (message.mac !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mac);
        /* int32 botNumber = 5; */
        if (message.botNumber !== 0)
            writer.tag(5, WireType.Varint).int32(message.botNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.LanScoreLinkDevice
 */
export const LanScoreLinkDevice = new LanScoreLinkDevice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SwapTeamDataResponse$Type extends MessageType<SwapTeamDataResponse> {
    constructor() {
        super("VpuScoreconnectGrpc.SwapTeamDataResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SwapTeamDataResponse>): SwapTeamDataResponse {
        const message = { success: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SwapTeamDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SwapTeamDataResponse): SwapTeamDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SwapTeamDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.SwapTeamDataResponse
 */
export const SwapTeamDataResponse = new SwapTeamDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Empty$Type extends MessageType<Empty> {
    constructor() {
        super("VpuScoreconnectGrpc.Empty", []);
    }
    create(value?: PartialMessage<Empty>): Empty {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Empty>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Empty): Empty {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Empty, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuScoreconnectGrpc.Empty
 */
export const Empty = new Empty$Type();
/**
 * @generated ServiceType for protobuf service VpuScoreconnectGrpc.ScoreConnectService
 */
export const ScoreConnectService = new ServiceType("VpuScoreconnectGrpc.ScoreConnectService", [
    { name: "SetScoreConnect3Configuration", options: {}, I: Configuration, O: StatusResponse },
    { name: "GetVendorList", options: {}, I: Empty, O: VendorList },
    { name: "GetVendorSportsList", options: {}, I: Vendor, O: VendorSportsList },
    { name: "GetVendorConfigurations", options: {}, I: Vendor, O: VendorConfigurationList },
    { name: "GetCurrentConfiguration", options: {}, I: Empty, O: Configuration },
    { name: "GetConfiguredBotNumber", options: {}, I: Empty, O: BotnumberMessage },
    { name: "GetScoreBoardData", options: {}, I: Empty, O: ScoreBoardDataMessage },
    { name: "DiscoverLanDevices", options: {}, I: Empty, O: LanScoreLinkDeviceList },
    { name: "SwapTeamData", options: {}, I: Empty, O: SwapTeamDataResponse }
]);
